module.exports = __webpack_public_path__ + "static/img/star_person_service.4a3a1845.png";